

import Vue from 'vue'
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {IOrder} from "@/model/Order/orderInterfaces";
import {downloadFileByUrl} from "@/helpers/downloadHelper";
import {settings} from "@/plugins/settings";

  @Component({
    name: 'OOImages',
    components: {
    }
  })
  export default class OOImages extends Vue {

    @Prop()
    private order!: IOrder;

    private imgError: boolean = false;

    get imageUrl() {
      return `${settings.endpoint}image/orders/${this.order.id}`;
    }

    private onClick() {
      window.open(this.imageUrl);
    }

    private onDownload() {
      downloadFileByUrl(this.imageUrl, `order-${this.order.id}`);
    }

    private processError() {
      this.imgError = true;
    }

  }

